module.exports = "/shared/fonts/Eurostile/Eurostile Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/Eurostile/Eurostile Bold.ttf
// module id = 32
// module chunks = 13